import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationModal = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    confirmButtonClass,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{ zIndex: 9999 }}>
            <div className="bg-campus-surface rounded-2xl shadow-soft max-w-md w-full mx-4">
                <div className="p-6 border-b border-campus-border">
                    <h2 className="text-2xl font-heading font-bold text-campus-text-primary">{title}</h2>
                    <p className="text-campus-text-body mt-2">{message}</p>
                </div>
                <div className="p-6 border-t border-campus-border flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-6 py-2 border border-campus-border rounded-lg text-campus-text-body hover:bg-campus-bg transition font-semibold"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className={`px-6 py-2 text-white rounded-lg transition font-semibold ${confirmButtonClass}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmText: PropTypes.string.isRequired,
    cancelText: PropTypes.string.isRequired,
    confirmButtonClass: PropTypes.string.isRequired,
};

export default ConfirmationModal;
